import { render, staticRenderFns } from "./AmetrasPictureUploadFieldTemplate.vue?vue&type=template&id=39e873a6&"
import script from "./AmetrasPictureUploadFieldTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasPictureUploadFieldTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports